import React from "react";
import { Grid } from "semantic-ui-react";
import { socket } from "../../../../lib/socketio";
import _ from "lodash";
import { useHistory, useLocation } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { setUser } from "../../../../actions/navActions";

const IOCheckMacro_PSM4 = ({ title }) => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    socket.emit("get tag names", [{ display_id: 259 }, { display_id: 130 }]);
    socket.on("receive tag names", (data) => {
      settags(data.tags_data);
    });
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);

  const IOCheckTags = tags.flatMap((t) =>
    t.tag_display_subgroup === "P100 UNSATISFIED INTERLOCKS" ? [t] : [],
  );

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const NState = data[18464];
  const PState = data[18459];

  const GetILTag = (id, value) => {
    if (value === 1 && id === 34653) return "CV020_STATUS = 0 ";
    else if ((value === 0 ) && id === 40608 ) return 'FS170_STATUS = 1';
    else if ((value < 0.0 || value > 3.0) && id === 18557)
      return "0.0 < FT012 < 3.0";
    //PDT020
    else if ((value < 0.0 || value > 5.0) && id === 33578)
      return "0.0 < PDT020 < 5.0";
    //PDT380 -> range ?
    else if ((value < 0.0 || value > 5.0) && id === 33585)
      return "0.0 < PDT380 < 5.0";
    //PT410
    else if ((value < 0.0 || value > 10.0) && id === 33599)
      return "0.0 < PT410 < 10.0";
    //PT720
    else if ((value < 0.0 || value > 10.0) && id === 33613)
      return "0.0 < PT720 < 10.0";
    else if ((value < -30 || value > 250) && id === 19402)
      return "-270 < TE380 < 2000";
    else if ((value < -30 || value > 250) && id === 19514)
      return "-270 < TE385 < 2000";
    else if ((value < -270 || value > 2000) && id === 21188)
      return "-270 < TE110FT < 2000";
    else if ((value < -270 || value > 2000) && id === 21181)
      return "-270 < TE120FT < 2000";
    else if ((value < -270 || value > 2000) && id === 21184)
      return "-270 < TE300FT < 2000";
    else if ((value < -270 || value > 2000) && id === 21187)
      return "-270 < TE090FT < 2000";
    // IDC1 조건 ?
    else if ((value < -999 || value > 999) && id === 21142)
      return "-999 < IDC_1 < 999";
    else if ((value < -999 || value > 999) && id === 21143)
      return "-999 < IDC_2 < 999";
    else if ((value < -999 || value > 999) && id === 21144)
      return "-999 < IDC_3 < 999";
  };

  const ILColumn = _.times(1, (i) =>
    IOCheckTags.map((r) => (
      <Grid.Column
        key={r.id}
        width="4"
        style={{ textAlign: "center", marginBottom: "10px" }}
      >
        {GetILTag(r.id, data[r.id])}{" "}
      </Grid.Column>
    )),
  );

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1>PRE-START IO CHECKS : PSM4</h1>
      <Grid inverted divided centered columns="equal" style={styles.grid}>
        <Grid.Column style={{ maxWidth: "1200px", padding: "0" }}>
          <Grid inverted divided centered columns="equal" style={styles.grid}>
            <Grid.Row>
              <Grid.Column>
                {PState === 100 ? (
                  <p>{ILColumn}</p>
                ) : (
                  <p style={{ fontSize: "15px", color: "yellow" }}>
                    Only Show in P100{" "}
                  </p>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid>
    </div>
  );
};
const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "15px",
  },
  grid: {
    paddingBottom: "0",
    paddingTop: "20px",
    paddingLeft: "10px",
  },
};

export default IOCheckMacro_PSM4;
